import React, { useEffect, useState, Fragment } from "react";
import { useLocation } from 'react-router-dom';
import { Helmet } from "react-helmet";
import QueryString from 'query-string';
import { Button } from '@material-ui/core';
import { Row, Container, Col, Image } from "react-bootstrap";
import { retrieveAccount } from '../../account';
import { getSessionStorageItem, SESSION_STORAGE_ACCOUNT_KEY } from '../../sessionStorage';
import BeforeFooter from '../BeforeFooter/BeforeFooter';
import Carriers from '../Home/Carriers/Carriers';
import Products from '../../components/Helpers/Data/Products/Products';
import './PartnerReferral.scss';
import CardVertical from "../Common/CardVertical";

const PartnerReferral = (props) => {

  const [account] = useState(getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY))
  const buttonLabel = props.buttonLabel || 'CONTINUE';

  const [error, setError] = useState(false);
  const [productList, setProductList] = useState(false);

  const parseUtm = (location) => {
    const queryString = QueryString.parse(location.search);
    return JSON.stringify(Object.entries(queryString)
      .filter(key => key[0].substring(0, 4) === "utm_").map(u => {
        return u.reduce((k, v) => {
          return { [k]: v };
        })
      }));
  }

  let location = useLocation();
  let carrierName;
  let carrierLogoUrl;
  let carrierForwardLink;

  account.accountOverrides ? carrierName = account.accountOverrides[0].carrierName : carrierName = "Covr";
  account.accountOverrides ? carrierLogoUrl = account.accountOverrides[0].carrierLogoUrl : carrierLogoUrl = "";
  account.accountOverrides ? carrierForwardLink = account.accountOverrides[0].carrierForwardLink : carrierForwardLink = "";

  useEffect(() => {
    if (!account || !account.account) {
      return;
    }

    if (account.account.redirectUrl) {
      props.history.push(account.account.redirectUrl);
    }

    var accountObj = getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY);

    if (!accountObj) {
      retrieveAccount(parseUtm(location))
        .then((account) => {
          if (!account.accountProducts.length) {
            account.accountProducts = Products();
          }

        })
        .catch((error) => {
          setError(true);

          return;
        });
    }
    var productList1 = account.accountProducts;

    productList1 = productList1.filter((item) => {
      return item.filterKey === props.filterKey;
    });

    setProductList(productList1);
  }, [account]);


  return (
    <div>
      <Container fluid className="home">
          <Fragment>
            <Helmet>
              <title>Insurance from {account.account.accountName}</title>
            </Helmet>

          {account && account.accountOverrides &&
            <Row className="justify-content-center redirect-row">
              <Col className="content-section">
                <h3>Insurance offers from {carrierName}</h3>
                <Row className="justify-content-center partner-redirect-box">
                  <Col sm={3} className="text-center">
                    <Image src={carrierLogoUrl} className="img-fluid carrier-image" />
                  </Col>
                  <Col sm={6} className="my-auto">
                    <div className="justify-content-center text-center align-middle">
                      Get a quote from {carrierName}
                    </div>
                  </Col>
                  <Col sm={3}>
                    <Button variant="outlined" size="large" href={carrierForwardLink} className='btn-wide-sm float-right MuiButton-textPrimary'>{buttonLabel}</Button>
                  </Col>
                </Row>
              </Col>
            </Row>
          }
            {/* Product Tile Section */}
            <Row className="justify-content-center product-tiles">
              <Row className="justify-content-center">
                <Col className="content-section">
                  <Row className="justify-content-center">
                    <h2>Get a Custom Quote</h2>
                  <p>Covr gets quotes from across the industry in a single process. Compare and save with a multi-carrier life insurance quote.</p>
                  <Col className="content-section">
                  <Row className="justify-content-center">
                    {productList.length ? productList.map((p, index) => {
                    return (
                      <Col key={index} sm="3" className="pb-3">
                        <CardVertical
                          detailsLink={p.productLink}
                          name={p.displayName}
                          icon={p.productIconPath}
                        />
                      </Col>)
                  }) :
                    <div>No products to show</div>
                  }
                  </Row>
                </Col>
                  </Row>
                </Col>
              </Row>
            </Row>
            <Carriers
              carrierVerbiage="We shop the top rated carriers to find your best value"
              carousel={true}
            />
            <BeforeFooter title="Get term life insurance from start to finish completely online." href="#product-tiles" />
          </Fragment>
      </Container>
    </div>
  );
}

export default PartnerReferral;



// WEBPACK FOOTER //
// ./src/components/PartnerReferral/PartnerReferral.js